import {MonoTypeOperatorFunction} from 'rxjs';
import {map} from 'rxjs/operators';

export function trim(): MonoTypeOperatorFunction<string> {
  return source => source.pipe(map(value => value.trim()));
}
